import React, { useState, useEffect } from 'react'
import { ReactComponent as FavouriteIcon } from '../../../assets/icons/favorite.svg'
import { ReactComponent as FavouritedIcon } from '../../../assets/icons/favorited.svg'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import {
    capitalizeFirstAndLowercaseRest,
    SHOW_CONVERSATION_PAGES
} from '../../helpers/Util'
import PackSetOrTag from './PackOrSetTag'
import DesignImages from './DesignImages'
import SetStyleMainFabricType from './SetStyleMainFabricType'
import { openDesignView } from '../../redux_toolkit/Design/DesignViewSlice'

const DesignCardView = ({ designInfo, triggerIsFavourite, requestFrom }) => {
    const [openConversationId, setOpenConversationId] = useState(null)
    const [collectionMembers, setCollectionMembers] = useState([])
    const dispatch = useDispatch()

    // For hide the bottom footer
    useEffect(() => {
        const element = document.getElementById('mobile-footer')
        if (element) {
            if (openConversationId) {
                element.classList.add('hide-mobile-footer')
            } else {
                element.classList.remove('hide-mobile-footer')
            }
        }
    }, [openConversationId])

    const onClickDesign = () => {
        dispatch(
            openDesignView({
                styleId: designInfo.id,
                styleInfo: designInfo,
                isShowConversation:
                    SHOW_CONVERSATION_PAGES.includes(requestFrom),
                requestFrom,
                toggleFavouriteHandler: toggleFavouriteModal
            })
        )
    }

    const toggleFavouriteModal = async (bool, isShowFav = true) => {
        try {
            dispatch(openLoader())
            await triggerIsFavourite(bool, designInfo, isShowFav)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    return (
        <>
            <div
                className={`${
                    !designInfo?.backImageDocument?.docUrl || designInfo?.isSet
                        ? 'single-card-item no-rotation'
                        : 'single-card-item'
                }`}
            >
                <div className='style-status flex items-center gap-1'>
                    {designInfo?.isSold && (
                        <span className='status sold'>Sold</span>
                    )}
                    {designInfo?.isNew && (
                        <span className='status new'>New</span>
                    )}
                    {designInfo?.isPack && <PackSetOrTag tagName='Pack' />}
                    {designInfo?.isSet && <PackSetOrTag tagName='Set' />}
                </div>

                <DesignImages
                    designInfo={designInfo}
                    callback={onClickDesign}
                />
                <div className='style-info'>
                    <div
                        className='info cursor-pointer'
                        onClick={onClickDesign}
                    >
                        <p className='regular-18 weight-500'>
                            {designInfo?.subCategoryResponse?.name &&
                                capitalizeFirstAndLowercaseRest(
                                    designInfo?.subCategoryResponse?.name
                                )}
                            {!designInfo?.subCategoryResponse?.name &&
                                designInfo?.subCategory &&
                                capitalizeFirstAndLowercaseRest(
                                    designInfo?.subCategory
                                )}
                            {designInfo?.isSet && designInfo?.name}
                        </p>
                        <ul className='common-list-component mt-1'>
                            {designInfo?.mainFabricType && (
                                <li className='regular-14'>
                                    {capitalizeFirstAndLowercaseRest(
                                        designInfo?.mainFabricType
                                    )}
                                </li>
                            )}
                            {designInfo?.referenceNumber &&
                                !designInfo?.isSet && (
                                    <li className='regular-14'>
                                        {designInfo?.referenceNumber}
                                    </li>
                                )}
                        </ul>
                        {designInfo?.isSet && (
                            <ul className='common-list-component mt-1'>
                                <SetStyleMainFabricType product={designInfo} />
                            </ul>
                        )}
                    </div>
                    <div className='favorite'>
                        <button
                            className='button secondary icon-only'
                            onClick={() => toggleFavouriteModal(true)}
                        >
                            <FavouriteIcon />
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DesignCardView
